(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cookie-banner]');
    if (!root) return;
    var KEY = 'glow_cookie_consent';

    function readCookie() {
      var m = document.cookie.match(new RegExp('(?:^|; )' + KEY + '=([^;]*)'));
      return m ? m[1] : null;
    }
    function writeCookie(value) {
      var d = new Date();
      d.setTime(d.getTime() + 365 * 864e5);
      document.cookie = KEY + '=' + value + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    }
    function applyConsent(analytics, marketing) {
      try {
        window.Shopify && Shopify.loadFeatures && Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (err) {
            if (err) return;
            try {
              window.Shopify.customerPrivacy.setTrackingConsent(
                { analytics: analytics, marketing: marketing, preferences: analytics, sale_of_data: marketing },
                function () {}
              );
            } catch (e) {}
          }
        );
      } catch (e) {}
    }
    function close(analytics, marketing) {
      writeCookie(analytics && marketing ? 'all' : (!analytics && !marketing ? 'none' : 'custom'));
      applyConsent(analytics, marketing);
      root.hidden = true;
    }

    if (!readCookie()) root.hidden = false;

    var mainView = root.querySelector('[data-cb-main]');
    var prefsView = root.querySelector('[data-cb-prefs]');
    root.querySelector('[data-cb-accept]').addEventListener('click', function () { close(true, true); });
    root.querySelector('[data-cb-reject]').addEventListener('click', function () { close(false, false); });
    root.querySelector('[data-cb-customize]').addEventListener('click', function () {
      mainView.hidden = true; prefsView.hidden = false;
    });
    root.querySelector('[data-cb-back]').addEventListener('click', function () {
      prefsView.hidden = true; mainView.hidden = false;
    });
    root.querySelector('[data-cb-save]').addEventListener('click', function () {
      close(
        root.querySelector('[data-cb-analytics]').checked,
        root.querySelector('[data-cb-marketing]').checked
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-featured-products]').forEach((root) => {
      const track = root.querySelector('[data-track]');
      const prev = root.querySelector('[data-arrow-prev]');
      const next = root.querySelector('[data-arrow-next]');
      if (!track) return;
      const step = () => Math.max(280, track.clientWidth * 0.6);
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left:  step(), behavior: 'smooth' }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const cols = document.querySelectorAll('.footer__column');
    if (!cols.length) return;
    const mq = window.matchMedia('(min-width: 1024px)');
    const sync = () => {
      cols.forEach((d) => {
        if (mq.matches) d.setAttribute('open', '');
        else d.removeAttribute('open');
      });
    };
    sync();
    mq.addEventListener('change', sync);
    // Keep desktop columns from being toggled shut via the summary
    cols.forEach((d) => {
      const summary = d.querySelector('.footer__column-summary');
      summary && summary.addEventListener('click', (e) => {
        if (mq.matches) e.preventDefault();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-site-header]');
    if (!root) return;

    // Sticky / hide-on-scroll-down
    const mode = root.dataset.stickyMode || 'always';
    if (mode !== 'off') {
      let lastY = window.scrollY;
      let pinned = true;
      function updateSticky() {
        const y = window.scrollY;
        const goingDown = y > lastY;
        if (mode === 'always') {
          pinned = true;
        } else if (mode === 'scroll_up') {
          if (y <= 0) pinned = true;
          else if (goingDown && y > 60) pinned = false;
          else if (!goingDown) pinned = true;
        }
        root.style.transform = pinned ? 'translateY(0)' : 'translateY(-100%)';
        lastY = y;
      }
      root.style.transition = (root.style.transition || '') + ', transform 240ms ease';
      window.addEventListener('scroll', updateSticky, { passive: true });
      updateSticky();
    }

    // Live offset for downstream sticky elements
    function exposeOffset() {
      const r = root.getBoundingClientRect();
      const offset = Math.max(0, r.bottom);
      document.documentElement.style.setProperty('--site-header-offset', offset + 'px');
      document.documentElement.style.setProperty('--site-header-height', r.height + 'px');
    }
    exposeOffset();
    window.addEventListener('scroll', exposeOffset, { passive: true });
    window.addEventListener('resize', exposeOffset);
    // The bar's padding animates when flipping transparent<->solid; the last
    // scroll event can catch a mid-transition height and leave the hero's
    // negative margin short (white gap above the hero). Re-measure when the
    // transitions settle.
    root.addEventListener('transitionend', exposeOffset);
    const barEl = root.querySelector('.site-header__bar');
    if (barEl) barEl.addEventListener('transitionend', exposeOffset);

    // Transparent → solid when the hero (or PDP gallery top) scrolls out
    if (root.dataset.transparent === 'true') {
      document.documentElement.dataset.headerTransparent = 'true';
      const hero = document.querySelector('.section-hero-image, [data-hero-image], .hero-image');
      const pdp = hero ? null : document.querySelector('.section-main-product');
      if (pdp) root.classList.add('site-header--fg-dark');
      function update() {
        if (hero) {
          const r = hero.getBoundingClientRect();
          const past = r.bottom <= (root.getBoundingClientRect().height + 4);
          root.classList.toggle('is-solid', past);
        } else if (pdp) {
          root.classList.toggle('is-solid', window.scrollY > 60);
        } else {
          root.classList.add('is-solid');
        }
      }
      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }

    // Cart open dispatcher
    const cartBtn = root.querySelector('[data-cart-toggle]');
    if (cartBtn) {
      cartBtn.addEventListener('click', (e) => {
        const drawer = document.querySelector('[data-cart-drawer]');
        if (!drawer) return;
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
    }

    // Search modal dispatcher (falls back to /search link if the modal is absent)
    const searchBtn = root.querySelector('.site-header__search');
    if (searchBtn) {
      searchBtn.addEventListener('click', (e) => {
        const modal = document.querySelector('[data-search-modal]');
        if (!modal) return;
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('search:open'));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      const opener = e.target.closest('[data-ig-open]');
      if (opener) {
        const id = opener.getAttribute('data-ig-open');
        const dlg = document.getElementById(id);
        if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); }
        return;
      }
      const closer = e.target.closest('[data-ig-close]');
      if (closer) {
        const dlg = closer.closest('dialog');
        if (dlg) dlg.close();
        return;
      }
      const dlg = e.target.matches('dialog[data-ig-modal]') ? e.target : null;
      if (dlg) dlg.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.pdp');
    if (!root) return;

    // Gallery carousel + counter (mobile)
    const grid = root.querySelector('[data-gallery-grid]');
    const count = root.querySelector('[data-gallery-count]');
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    if (grid && count) {
      const updateCount = () => {
        const w = grid.clientWidth || 1;
        const slide = Math.round(grid.scrollLeft / w);
        const total = grid.children.length;
        count.textContent = (slide + 1) + '/' + total;
      };
      grid.addEventListener('scroll', updateCount, { passive: true });
      updateCount();
      prev && prev.addEventListener('click', () => {
        grid.scrollBy({ left: -grid.clientWidth, behavior: 'smooth' });
      });
      next && next.addEventListener('click', () => {
        grid.scrollBy({ left: grid.clientWidth, behavior: 'smooth' });
      });
    }

    const form = root.querySelector('[data-pdp-form]');
    if (!form) return;
    const variantInput = form.querySelector('[data-variant-input]');
    const ctas = Array.prototype.slice.call(form.querySelectorAll('[data-cta]'));
    const cta = ctas[0];
    const ctaLabels = Array.prototype.slice.call(form.querySelectorAll('[data-cta-label]'));
    const ctaPrices = Array.prototype.slice.call(form.querySelectorAll('[data-cta-price]'));
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-price-compare]');
    const sizeBtns = form.querySelectorAll('[data-size-btn]');

    const variantMap = {};
    const dataScript = root.querySelector('[data-pdp-variants]');
    if (dataScript) {
      try {
        const arr = JSON.parse(dataScript.textContent);
        arr.forEach((v) => { variantMap[v.id] = { available: v.available, price: v.price, compare_at: v.compare_at }; });
      } catch (e) {}
    }

    const CTA_ADD = root.getAttribute('data-cta-add') || 'Add to cart';
    const CTA_SOLD = root.getAttribute('data-cta-sold') || 'Sold out';
    const CTA_SELECT = root.getAttribute('data-cta-select') || 'Select size';

    const applyVariant = (vid) => {
      const v = variantMap[vid];
      if (!v) return;
      ctaLabels.forEach((el) => { el.textContent = v.available ? CTA_ADD : CTA_SOLD; });
      ctaPrices.forEach((el) => { el.textContent = v.price; });
      ctas.forEach((b) => { b.disabled = !v.available; });
      form.classList.toggle('pdp__form--soldout', !v.available);
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        const hasCompare = v.compare_at && v.compare_at !== '' && v.compare_at !== v.price;
        compareEl.textContent = hasCompare ? v.compare_at : '';
        compareEl.hidden = !hasCompare;
      }
    };

    const sizeValueEl = root.querySelector('[data-size-value]');
    sizeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        sizeBtns.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        if (sizeValueEl) sizeValueEl.textContent = btn.textContent.trim();
        const vid = btn.getAttribute('data-variant-id');
        variantInput.value = vid;
        applyVariant(vid);
      });
    });

    // Main CTA — AJAX add, then reload + reopen drawer (SSR drawer needs the reload)
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (cta.disabled) return;
      ctas.forEach((b) => b.classList.add('is-adding'));
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantInput.value), quantity: 1 })
      })
        .then((r) => { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(() => {
          sessionStorage.setItem('pdpOpenCart', '1');
          window.location.reload();
        })
        .catch(() => { ctas.forEach((b) => b.classList.remove('is-adding')); });
    });

    // Shipping cutoff countdown (Rains "order within Xh Ym" line)
    const shipnote = root.querySelector('[data-shipnote]');
    if (shipnote) {
      const line = shipnote.querySelector('[data-shipnote-countdown]');
      const timer = shipnote.querySelector('[data-shipnote-timer]');
      const cutoffHour = parseInt(shipnote.getAttribute('data-cutoff-hour'), 10) || 17;
      const tick = () => {
        const now = new Date();
        const cutoff = new Date(now);
        cutoff.setHours(cutoffHour, 0, 0, 0);
        const diff = cutoff.getTime() - now.getTime();
        if (diff <= 0) { line.hidden = true; return; }
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        timer.textContent = h + 'h ' + m + 'm';
        line.hidden = false;
      };
      tick();
      setInterval(tick, 30000);
    }

    // One-size guide drawer
    const osg = root.querySelector('[data-one-size-guide]');
    if (osg) {
      const openOsg = () => {
        osg.hidden = false;
        requestAnimationFrame(() => osg.classList.add('is-open'));
      };
      const closeOsg = () => {
        osg.classList.remove('is-open');
        setTimeout(() => { osg.hidden = true; }, 280);
      };
      root.querySelectorAll('[data-osg-open]').forEach((b) => b.addEventListener('click', openOsg));
      osg.querySelectorAll('[data-osg-close]').forEach((b) => b.addEventListener('click', closeOsg));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !osg.hidden) closeOsg();
      });
    }

    // Fit quiz — EasySize-style stepped popup, local heuristic, no third party
    const fqModal = root.querySelector('[data-fit-quiz]');
    const fqBtn = root.querySelector('[data-fq-open]');
    if (fqModal && fqBtn && sizeBtns.length) {
      const FQ_KEY = 'clabFitSize';
      const eyebrowText = fqModal.getAttribute('data-fq-eyebrow') || 'Take our Fit Quiz';
      const resultLabel = fqModal.getAttribute('data-fq-result-label') || 'My size is';
      const body = fqModal.querySelector('[data-fq-body]');
      const stepEl = fqModal.querySelector('[data-fq-step]');
      const backBtn = fqModal.querySelector('[data-fq-back]');
      const sizeNames = Array.prototype.slice.call(sizeBtns).map((b) => b.textContent.trim());

      const STEPS = [
        { key: 'size',   q: 'What size do you usually wear?', options: sizeNames },
        { key: 'height', q: 'How tall are you?',              options: ['Under 160 cm', '160–170 cm', '170–180 cm', 'Over 180 cm'] },
        { key: 'weight', q: 'How much do you weigh?',         options: ['Under 55 kg', '55–70 kg', '70–85 kg', 'Over 85 kg'] },
        { key: 'fit',    q: 'How do you like your fit?',      options: ['Tighter', 'Regular', 'Looser'] }
      ];
      let step = 0;
      const answers = {};

      const selectSizeByName = (name) => {
        const target = Array.prototype.slice.call(sizeBtns).find(
          (b) => b.textContent.trim() === name && !b.disabled
        );
        if (target) target.click();
      };

      const computeSize = () => {
        let idx = answers.size;
        let delta = answers.fit - 1;
        if (answers.weight - answers.height >= 2) delta += 1;
        if (answers.height - answers.weight >= 2) delta -= 1;
        idx = Math.min(sizeNames.length - 1, Math.max(0, idx + delta));
        let best = idx;
        if (sizeBtns[best] && sizeBtns[best].disabled) {
          for (let off = 1; off < sizeNames.length; off++) {
            if (sizeBtns[best + off] && !sizeBtns[best + off].disabled) { best = best + off; break; }
            if (sizeBtns[best - off] && !sizeBtns[best - off].disabled) { best = best - off; break; }
          }
        }
        return sizeNames[best];
      };

      const render = () => {
        body.innerHTML = '';
        if (step < STEPS.length) {
          const s = STEPS[step];
          backBtn.hidden = step === 0;
          stepEl.textContent = (step + 1) + '/' + STEPS.length;
          if (step === 0) {
            const eb = document.createElement('p');
            eb.className = 'pdp__fq-eyebrow';
            eb.textContent = eyebrowText;
            body.appendChild(eb);
          }
          const q = document.createElement('h2');
          q.className = 'pdp__fq-q';
          q.textContent = s.q;
          body.appendChild(q);
          const opts = document.createElement('div');
          opts.className = 'pdp__fq-opts';
          s.options.forEach(function (label, i) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'pdp__fq-opt';
            b.textContent = label;
            if (answers[s.key] === i) b.classList.add('is-selected');
            b.addEventListener('click', function () {
              answers[s.key] = i;
              step += 1;
              render();
            });
            opts.appendChild(b);
          });
          body.appendChild(opts);
        } else {
          const rec = computeSize();
          backBtn.hidden = false;
          stepEl.textContent = '';
          const q = document.createElement('h2');
          q.className = 'pdp__fq-q';
          q.textContent = 'Your recommended size is';
          q.style.marginBottom = '0';
          body.appendChild(q);
          const big = document.createElement('p');
          big.className = 'pdp__fq-result-size';
          big.textContent = rec;
          body.appendChild(big);
          const cta = document.createElement('button');
          cta.type = 'button';
          cta.className = 'pdp__fq-cta';
          cta.textContent = 'Select size ' + rec;
          cta.addEventListener('click', function () {
            try { localStorage.setItem(FQ_KEY, rec); } catch (e) {}
            fqBtn.textContent = resultLabel + ' ' + rec;
            selectSizeByName(rec);
            closeFq();
          });
          body.appendChild(cta);
          const retake = document.createElement('button');
          retake.type = 'button';
          retake.className = 'pdp__fq-retake';
          retake.textContent = 'Retake quiz';
          retake.addEventListener('click', function () {
            step = 0;
            render();
          });
          body.appendChild(retake);
          try { localStorage.setItem(FQ_KEY, rec); } catch (e) {}
          fqBtn.textContent = resultLabel + ' ' + rec;
        }
      };

      const openFq = () => {
        step = 0;
        render();
        fqModal.hidden = false;
        requestAnimationFrame(function () { fqModal.classList.add('is-open'); });
      };
      const closeFq = () => {
        fqModal.classList.remove('is-open');
        setTimeout(function () { fqModal.hidden = true; }, 260);
      };

      fqBtn.addEventListener('click', openFq);
      backBtn.addEventListener('click', function () {
        if (step > 0) { step -= 1; render(); }
      });
      fqModal.querySelectorAll('[data-fq-close]').forEach(function (b) {
        b.addEventListener('click', closeFq);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !fqModal.hidden) closeFq();
      });

      try {
        const stored = localStorage.getItem(FQ_KEY);
        if (stored && sizeNames.indexOf(stored) !== -1) {
          fqBtn.textContent = resultLabel + ' ' + stored;
        }
      } catch (e) {}
    }

    // Upsells — variant match from selects, AJAX add, reopen drawer after reload
    root.querySelectorAll('[data-upsell]').forEach((card) => {
      let variants = [];
      const dataEl = card.querySelector('[data-upsell-variants]');
      if (dataEl) {
        try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      }
      const selects = Array.prototype.slice.call(card.querySelectorAll('[data-opt-select]'));
      const btn = card.querySelector('[data-upsell-add]');
      const priceEl = card.querySelector('[data-upsell-price]');

      const findVariant = () => {
        if (!selects.length) return variants[0] || null;
        const chosen = selects.map((s) => s.value);
        return variants.find((va) => va.options.every((o, i) => o === chosen[i])) || null;
      };
      const sync = () => {
        selects.forEach((s) => {
          const opt = s.closest('.pdp__upsell-opt');
          const valEl = opt ? opt.querySelector('[data-opt-value]') : null;
          if (valEl) valEl.textContent = s.value;
        });
        const va = findVariant();
        if (btn) btn.disabled = !va || !va.available;
        if (priceEl && va) priceEl.textContent = va.price;
      };
      selects.forEach((s) => s.addEventListener('change', sync));
      sync();

      btn && btn.addEventListener('click', () => {
        const hasHiddenSize = card.querySelector('.pdp__upsell-opt--size') && !card.classList.contains('is-opts-open');
        if (hasHiddenSize) {
          card.classList.add('is-opts-open');
          return;
        }
        const va = findVariant();
        if (!va) return;
        btn.disabled = true;
        btn.classList.add('is-adding');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: va.id, quantity: 1 })
        })
          .then((r) => { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(() => {
            sessionStorage.setItem('pdpOpenCart', '1');
            window.location.reload();
          })
          .catch(() => { btn.disabled = false; btn.classList.remove('is-adding'); });
      });
    });
    if (sessionStorage.getItem('pdpOpenCart') === '1') {
      sessionStorage.removeItem('pdpOpenCart');
      setTimeout(() => document.dispatchEvent(new CustomEvent('cart:open')), 300);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["megamenu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-megamenu]');
    if (!root) return;
    const panels = root.querySelectorAll('[data-megamenu-panel]');
    const close = root.querySelectorAll('[data-megamenu-close]');
    const HOVER_CLOSE_DELAY = 180;
    let closeTimer = null;
    let openMode = null;
    const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;

    function cancelClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }
    function scheduleClose() {
      cancelClose();
      closeTimer = setTimeout(closeMenu, HOVER_CLOSE_DELAY);
    }
    function openPanel(key, mode) {
      cancelClose();
      openMode = mode || 'click';
      panels.forEach((p) => p.classList.toggle('is-active', !key || p.dataset.key === key));
      root.setAttribute('data-megamenu-active', 'true');
      root.setAttribute('aria-hidden', 'false');
      document.dispatchEvent(new CustomEvent('overlay:open', { detail: { source: 'megamenu' } }));
    }
    function closeMenu() {
      cancelClose();
      openMode = null;
      root.removeAttribute('data-megamenu-active');
      root.setAttribute('aria-hidden', 'true');
      document.dispatchEvent(new CustomEvent('overlay:close', { detail: { source: 'megamenu' } }));
    }

    close.forEach((b) => b.addEventListener('click', closeMenu));
    document.addEventListener('backdrop:click', closeMenu);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });

    document.addEventListener('megamenu:open', (e) => {
      const key = e.detail && e.detail.key;
      openPanel(key, 'click');
    });
    document.addEventListener('megamenu:close', closeMenu);

    // Keep open while pointer is over the panel; schedule close when it leaves.
    root.addEventListener('mouseenter', cancelClose);
    root.addEventListener('mouseleave', () => {
      if (openMode === 'hover') scheduleClose();
    });

    document.querySelectorAll('[data-megamenu-trigger]').forEach((el) => {
      el.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        openPanel(el.dataset.megamenuTrigger, 'hover');
      });
      el.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        if (openMode === 'hover') scheduleClose();
      });
      el.addEventListener('click', (e) => {
        if (!isDesktop()) return;
        e.preventDefault();
        openPanel(el.dataset.megamenuTrigger, 'click');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-nav-drawer]');
    if (!root) return;
    const scrim = document.querySelector('[data-nav-scrim]');
    function open() {
      root.setAttribute('data-nav-drawer-active', 'true');
      root.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.setAttribute('data-nav-scrim-active', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.dispatchEvent(new CustomEvent('overlay:open', { detail: { source: 'nav-drawer' } }));
    }
    function close() {
      root.removeAttribute('data-nav-drawer-active');
      root.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.removeAttribute('data-nav-scrim-active');
      document.documentElement.style.overflow = '';
      document.dispatchEvent(new CustomEvent('overlay:close', { detail: { source: 'nav-drawer' } }));
    }
    if (scrim) scrim.addEventListener('click', close);
    root.querySelectorAll('[data-nav-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('nav-drawer:open', open);
    document.addEventListener('nav-drawer:close', close);
    document.addEventListener('backdrop:click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    document.querySelectorAll('[data-nav-toggle]').forEach((el) => {
      el.addEventListener('click', open);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    const input = modal.querySelector('.search-modal__input');

    const open = () => {
      modal.hidden = false;
      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        if (input) input.focus();
      });
      document.documentElement.style.overflow = 'hidden';
    };
    const close = () => {
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(() => { modal.hidden = true; }, 240);
    };

    document.addEventListener('search:open', open);
    modal.querySelectorAll('[data-search-close]').forEach((b) => b.addEventListener('click', close));
    modal.addEventListener('click', (e) => {
      if (e.target === modal || e.target.classList.contains('search-modal__content')) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
